import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Row, Col, Form, OverlayTrigger } from "react-bootstrap";
import { MdFilterList, MdAddCircle, MdEdit, MdDelete, MdRemoveRedEye } from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
import AppDataGrid from "../../components/common/AppDataGrid";
import { Tooltip } from '@mui/material';
import loading from "../../assets/images/common/loading.gif";






const LeaveEntry = () => {
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const handleShowFilterModal = () => setShowFilterModal(true);
    const [searchQuery, setSearchQuery] = useState("");
    // const [filter, setFilter] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const userData = sessionStorage.getItem('user');
    const [leaves, setleaves] = useState([]);
    const userObj = userData ? JSON.parse(userData) : {};
    const [balance, setBalance] = useState([]);
    const [showViewForm, setViewForm] = useState(false);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const navigate = useNavigate();
    const [form, setForm] = useState({
        leave_entry_id: "",
        userid: "",
        leave_id: "",
        apply_date: "",
        from_date: "",
        to_date: "",
        reason: "",
        approved_by: "",
        approved_date: "",
        status: "",
        school_id: "",
        user_name: "",
        leave_description: "",
        approved_by_name: "",
        school_name: "",
        total_days: "",
        rejected_reason: "",

    })

    const [filter, setFilter] = useState({
        from_date: "",
        to_date: "",
        total_days: "",
        reason: "",
        half_day_type: "",
        status: "",
        leave_description: "",
        leave_name: "",
    });




    const formatDate1 = (datetime) => {
        if (!datetime) return "";
        const date = new Date(datetime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    const fetchleaves = async () => {
        try {
            const response = await axios.post(baseUrl + "/LeaveEntryRead/", {
                action: "FILTER",
                userid: userObj.user_id,
                school_id: userObj.school_id,
                total_days: filter.total_days && !isNaN(filter.total_days)
                    ? Number(filter.total_days)
                    : null,
            });
            setleaves(response.data || []);
        } catch (error) {
            console.error("Error fetching leaves:", error);
        }
    };


    const LeaveBalance = async () => {
        try {
            const response = await axios.get(baseUrl + "/leaveBalance", {
                params: {
                    _userid: userObj.user_id,
                    _year_id: userObj.academic_year_id,
                    _school_id: userObj.school_id,
                },
            });


            if (Array.isArray(response.data)) {
                setBalance(response.data);
            } else {
                setBalance([]);
            }
        } catch (error) {
            console.error("Error fetching leaves:", error);
            setBalance([]);
        }
    };

    useEffect(() => {
        setIsLoading(true);
        fetchleaves().finally(() => setIsLoading(false));
        LeaveBalance();
    }, []);



    const handleDeleteClick = async (leave_entry_id) => {
        const confirmDelete = window.confirm('Are you sure you want to change the status?');
        if (!confirmDelete) {
            return;
        }
        const requestBody = {
            leave_entry_id: leave_entry_id,
            action: "DELETE"
        };
        try {
            alert(leave_entry_id);
            const response = await axios.post(baseUrl + '/LeaveEntry/', requestBody, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if (response.status < 200 || response.status >= 300) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            toast.success("Record Deleted Successfully");
            fetchleaves();
        } catch (error) {
            console.error('Error:', error);
        }
    };
    const handleReset = async (e) => {
        e.preventDefault();
        setFilter({
            from_date: "",
            to_date: "",
            total_days: "",
            action: "FILTER"

        });
        setShowFilterModal(true);
        fetchleaves();
    };

    const handleViewClick = (leave_entry_id) => {
        const leaveToView = leaves.find(leave => leave.leave_entry_id === leave_entry_id);
        if (leaveToView) {
            setForm(leaveToView);
            setViewForm(true);
        } else {
            console.error(`ID ${leave_entry_id} not found`);
        }
    };



    const columns = [
        {
            field: "leave_description",
            headerName: "Leave Type",
            flex: 1,

            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "from_date",
            headerName: "From Date",
            flex: 1,

            renderCell: (params) => (
                <Tooltip title={formatDate1(params.value)}>
                    <span className="cell-wrap">{formatDate1(params.value)}</span>
                </Tooltip>
            ),
        },
        {
            field: "to_date",
            headerName: "To Date",
            flex: 1,

            renderCell: (params) => (
                <Tooltip title={formatDate1(params.value)}>
                    <span className="cell-wrap">{formatDate1(params.value)}</span>
                </Tooltip>
            ),
        },
        {
            field: "total_days",
            headerName: "Total Days",
            flex: 1,

            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "reason",
            headerName: "Reason",
            flex: 2,

            renderCell: (params) => {
                const displayText =
                    params.value && params.value.length > 250
                        ? params.value.substring(0, 250) + "..."
                        : params.value;

                return (
                    <Tooltip title={params.value}>
                        <span className="cell-wrap" style={{ maxWidth: "250px" }}>
                            {displayText}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "half_day_type",
            headerName: "Half Day Type",
            flex: 1,

            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,

            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 1,

            sortable: false,
            renderCell: (params) =>
                params.row.total_days !== "No Records Found" && params.row.leave_entry_id ? (
                    <div className="tableActions">
                        {params.row.status === "Pending" ? (
                            <Tooltip title="Delete" arrow>
                                <span
                                    className="commonActionIcons"
                                    onClick={() => handleDeleteClick(params.row.leave_entry_id)}
                                >
                                    <MdDelete />
                                </span>
                            </Tooltip>
                        ) : (params.row.status === "Approved" || params.row.status === "Rejected") ? (
                            <Tooltip title="View" arrow>
                                <span
                                    className="commonActionIcons"
                                    onClick={() => handleViewClick(params.row.leave_entry_id)}
                                >
                                    <MdRemoveRedEye />
                                </span>
                            </Tooltip>
                        ) : null}
                    </div>
                ) : null,
        },
    ];





    const balanceColumns = [
        {
            field: "leave_name",
            headerName: "Leave Type",
            flex: 1,

            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "opening_balance",
            headerName: "Opening Balance",
            flex: 1,

            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "curr_balance",
            headerName: "Current Balance",
            flex: 1,

            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "used_leaves",
            headerName: "Used Leaves",
            flex: 1,

            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
    ];









    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => {
            const updatedForm = { ...prevForm, [id]: value };

            if (updatedForm.from_date && updatedForm.to_date) {
                const fromDate = new Date(updatedForm.from_date);
                const toDate = new Date(updatedForm.to_date);


                updatedForm.total_days = Math.floor((toDate - fromDate) / (1000 * 60 * 60 * 24)) + 1;
            } else {
                updatedForm.total_days = "";
            }


            if (updatedForm.total_days !== 1) {
                updatedForm.half_day_type = "";
            }

            return updatedForm;
        });
    };

    const handleFilterSubmit = async () => {
        try {
            const response = await axios.post(baseUrl + "/LeaveEntryRead/", {
                action: "FILTER",
                school_id: userObj.school_id,
                from_date: filter.from_date || "",
                to_date: filter.to_date || "",
                leave_description: filter.leave_description || "",
                leave_name: filter.leave_name || "",
                total_days: filter.total_days && !isNaN(filter.total_days)
                    ? Number(filter.total_days)
                    : null,



            });

            setleaves(response.data || []);
            handleCloseFilterModal();
        } catch (error) {

            setleaves([]);
            handleCloseFilterModal();

        }
    };


    const searchableColumns = [
        (row) => row.user_name,
        (row) => row.leave_description,
        (row) => formatDate1(row.from_date),   // must have row.
        (row) => formatDate1(row.to_date),
        (row) => row.total_days,
        (row) => row.reason,
        (row) => row.half_day_type,
        (row) => row.status,
    ];

    const filteredRecords = (leaves || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || '').toUpperCase().replace(/[-\s]+/g, '');
            const normalizedQuery = searchQuery.toUpperCase().replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };


    return (
        <div className='pageMain'>


            <div className="pageRight">

                <div style={{ padding: "20px" }}>
                    <h4>Leave Balance</h4>
                    <div className="commonTable height100">
                        <div className="tableBody">
                           
                            <AppDataGrid
                                     rows={balance}
                                     columns={balanceColumns}
                                     getRowId={(r) => r.leave_name}
                                     showToolbar={false}
                                     pagination
                                     pageSizeOptions={[10, 20, 50]}
                                     density="compact"
                                     
                                     maxHeight={500}
                                   />

                        </div>
                    </div>
                </div>

                <Modal show={showViewForm} onHide={() => setViewForm(false)} centered size="md" dialogClassName="custom-modal">
                    <Modal.Header closeButton>
                        <div className="d-flex justify-content-between w-100">
                            <Modal.Title>Apply Leave</Modal.Title>

                        </div>
                    </Modal.Header>




                    <Modal.Body style={{ minHeight: "380px", maxHeight: "75vh", overflowY: "auto" }}>
                        <Form id="ModalForm">
                            <Row className="px-3 pt-2 g-3">
                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>Leave Type:</strong>
                                    <span>{form.leave_description}</span>
                                </Col>

                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>From Date:</strong>
                                    <span>{formatDate1(form.from_date)}</span>
                                </Col>



                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>To Date:</strong>
                                    <span>{formatDate1(form.to_date)}</span>
                                </Col>


                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>Total Days:</strong>
                                    <span>{(form.total_days)}</span>
                                </Col>

                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>Reason:</strong>
                                    <span>{formatDate1(form.reason)}</span>
                                </Col>
                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>Half Day Type:</strong>
                                    <span>{form.half_day_type}</span>
                                </Col>

                                <Col md={6} className="mb-2 d-flex align-items-start">
                                    <strong style={{ width: "160px" }}>Status:</strong>
                                    <span>{form.status}</span>
                                </Col>
                                <Col md={6} className="mb-2 d-flex align-items-start">
                                    <strong style={{ width: "160px" }}>Rejected Reason:</strong>
                                    <span>{form.rejected_reason}</span>
                                </Col>




                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="d-flex w-100">
                        <Button
                            variant="secondary"
                            onClick={() => setViewForm(false)}
                        >
                            Close
                        </Button>


                    </Modal.Footer>


                </Modal>

                <div className="pageBody">
                    <ToastContainer />
                    <div className="commonDataTableHead">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                <h6 className="commonTableTitle">Apply Leave</h6>
                            </div>
                            <div className="">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchQuery}
                                    className="searchInput"
                                    maxLength={15}
                                    onChange={handleSearchChange}
                                />
                            </div>


                            <div className="d-flex align-items-center" style={{ gap: 6 }}>
                                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                                    <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                        <MdFilterList />
                                    </Button>
                                </OverlayTrigger>

                                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
                                    <Button className="primaryBtn" variant="primary" onClick={() => navigate("/addleaveentry")}>
                                        <MdAddCircle />
                                    </Button>
                                </OverlayTrigger>
                            </div>

                        </div>
                    </div>

                    <div className="commonTable height100">
                        <div className="tableBody">
                            {isLoading ? (
                                <div className="loadingContainer">
                                    <img src={loading} alt="Loading..." className="loadingGif" />
                                </div>
                            ) : (
                                 <AppDataGrid
                                     rows={filteredRecords}
                                     columns={columns}
                                     getRowId={(r) => r.leave_entry_id}
                                     showToolbar={false}
                                     pagination
                                     pageSizeOptions={[10, 20, 50]}
                                     density="compact"
                                     maxHeight={500}
                                   />

                            )}
                        </div>
                    </div>
                </div>



            </div>
            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Row>



                        <Col xs={12}>

                            <div className='commonInput'>
                                <Form.Group controlId="from_date">
                                    <Form.Label>From Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        id="from_date"
                                        value={filter.from_date || ""}
                                        onChange={(e) => {
                                            const value = e.target.value;


                                            if (filter.to_date && value > filter.to_date) {
                                                alert("From Date cannot be later than To Date");
                                                return;
                                            }

                                            setFilter((prev) => ({
                                                ...prev,
                                                from_date: value,
                                            }));
                                        }}
                                    />
                                </Form.Group>
                            </div>
                        </Col>

                        <div className='commonInput'>
                            <Form.Group controlId="to_date">
                                <Form.Label>To Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    id="to_date"
                                    value={filter.to_date || ""}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        if (filter.from_date && value < filter.from_date) {
                                            alert("To Date cannot be earlier than From Date");
                                            return;
                                        }
                                        setFilter((prev) => ({
                                            ...prev,
                                            to_date: value,
                                        }));
                                    }}
                                />
                            </Form.Group>
                        </div>
                        <div className='commonInput'>
                            <Form.Group controlId="total_days">
                                <Form.Label>Total Days</Form.Label>
                                <Form.Control
                                    type="number"
                                    id="total_days"
                                    value={filter.total_days || ""}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        // ✅ You can add validation like: total days cannot be negative
                                        if (value < 0) {
                                            alert("Total Days cannot be negative");
                                            return;
                                        }

                                        setFilter((prev) => ({
                                            ...prev,
                                            total_days: value,
                                        }));
                                    }}
                                />
                            </Form.Group>
                        </div>





                    </Row>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
                        Reset
                    </Button>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={() => { handleCloseFilterModal(); }}>
                            Cancel
                        </Button>
                        <Button variant="primary" className="btn-success primaryBtn" onClick={handleFilterSubmit}>

                            Search
                        </Button>
                    </div>
                </Modal.Footer>

            </Modal>
        </div>
    );

};
export default LeaveEntry;
